import type { Design, DesignModuleLink, DesignObject } from '../../types';

interface FunctionObject {
  id: string;
  name: string;
  script: string;
}

interface FunctionUsedIn {
  customNodes:DesignObject[];
  links: DesignModuleLink[];
}

export default class FunctionsUsedIn {
  static getFunctionUsedIn(objectFunction: FunctionObject, serialized: Design): FunctionUsedIn {
    const objects = serialized.components.objects.filter(
      (obj) => obj._class === 'CustomNodeModel'
    );
    const customNodes = FunctionsUsedIn.getFunctionUsedInCustomNodes(
      objectFunction,
      objects
    );

    const links = FunctionsUsedIn.getFunctionUsedInLinks(
      objectFunction.name,
      serialized.components.modules.flatMap((mod) => {
        return mod.versions[1].flow.links;
      })
    );

    return {
      customNodes,
      links
    };
  }

  static getFunctionUsedInCustomNodes(
    objectFunction: FunctionObject,
    objects: DesignObject[]
  ): FunctionUsedIn['customNodes'] {
    return objects.filter((custom) => {
      const fn = custom.props.config.function!;
      return  fn.script
        ? fn.script.includes(objectFunction.name)
        : fn.ref === objectFunction.id;
    });
  }

  static getFunctionUsedInLinks(
    functionName: string,
    links: DesignModuleLink[]
  ): FunctionUsedIn['links'] {
    return links.filter((link) => {
      return link.props.config.condition.some((conditions) => {
        return conditions.some((condition) => {
          return condition.includes(functionName);
        });
      });
    });
  }
}
